import { useEffect, useRef } from 'react'

// courtesy of https://usehooks.com/usePrevious/
export function usePrevious<T>(value: T | undefined) {
  const ref = useRef<T>()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}
